import { Message, OwnerTypeMessage } from "../models/Message";
import { User } from "../models/User";

export type MessageAttributionContext = {
  currentUser?: User | null;
  contactName?: string | null;
  organizationName?: string | null;
  emptyLabel?: string;
};

const nonEmpty = (...values: Array<string | null | undefined>) => {
  for ( const value of values ) {
    const trimmed = ( value ?? "" ).trim();
    if ( trimmed ) return trimmed;
  }

  return "";
};

export const resolveMessageSenderName = ( message: Message | null | undefined, context: MessageAttributionContext = {} ) => {
  const organizationName = nonEmpty( context.organizationName, context.currentUser?.organization?.name );
  const emptyLabel = context.emptyLabel ?? "";

  if ( !message ) return emptyLabel;

  if ( message.ownerType === OwnerTypeMessage.CONTACT ) {
    return nonEmpty( context.contactName, message.contact?.name, "Cliente" );
  }

  if ( message.ownerType === OwnerTypeMessage.BOT || message.ownerType === OwnerTypeMessage.ADMIN ) {
    return nonEmpty( organizationName, message.ownerType === OwnerTypeMessage.BOT ? "Bot" : emptyLabel );
  }

  if ( message.ownerType === OwnerTypeMessage.USER ) {
    if ( message.user?.name ) {
      return message.user?.id === context.currentUser?.id ? "Você" : message.user.name;
    }

    return nonEmpty( organizationName, emptyLabel );
  }

  return emptyLabel;
};

export const resolveLastMessageSenderLabel = ( message: Message | null | undefined, context: MessageAttributionContext = {} ) => {
  if ( !message || message.ownerType === OwnerTypeMessage.CONTACT ) return "";
  if ( message.fileMetadata && !( message.content ?? "" ).trim()) return "";

  return resolveMessageSenderName( message, context );
};

export const resolveMessageSenderAvatarReference = ( message: Message | null | undefined ) => {
  if ( !message ) return null;

  if ( message.ownerType === OwnerTypeMessage.USER || message.ownerType === OwnerTypeMessage.ADMIN ) {
    return message.user?.avatar ?? null;
  }

  return null;
};
